export default "__VITE_ASSET__WvFNIZE$__";